import { render, staticRenderFns } from "./company-info.vue?vue&type=template&id=9668cdea&scoped=true&"
import script from "./company-info.vue?vue&type=script&lang=js&"
export * from "./company-info.vue?vue&type=script&lang=js&"
import style0 from "./company-info.vue?vue&type=style&index=0&id=9668cdea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9668cdea",
  null
  
)

export default component.exports